import React from 'react'
import Layout from '../layout/layout'

const NotFound: React.FC = () => {
  return (
    <Layout>
      <h1>Page Not Found</h1>
    </Layout>
  )
}

export default NotFound
